import { useState, useEffect, useMemo } from "react";
import { APIProvider, ColorScheme, Map, AdvancedMarker, Pin, useMap } from "@vis.gl/react-google-maps";
import CinemaMarker from "./CinemaMarker";

// Create a map controller component to handle map interactions
function MapController({ userLocation }) {
  const map = useMap();

  useEffect(() => {
    if (map && userLocation) {
      console.log("Panning map to user location:", userLocation);
      map.panTo(userLocation);
    }
  }, [map, userLocation]);

  return null; // This is just a controller component, it doesn't render anything
}

const CinemaMap = ({
  schedules,
  selectedMovies,
  selectedDimensions
}) => {
  const [cinemas, setCinemas] = useState([]);
  const [initialCenter, setInitialCenter] = useState({ lat: -26.2041, lng: 28.0473 })
  const [userLocation, setUserLocation] = useState(null);



  useEffect(() => {
    fetch('/api/cinemas')
      .then(res => res.json())
      .then(data => setCinemas(data))
      .catch(err => console.error('Failed to load cinemas', err));
  }, []);

  // 1) Compute which cinemas to show
  const filteredCinemas = useMemo(() => {
    const noFilters =
      selectedMovies.length === 0 && selectedDimensions.length === 0;

    // a) No filters => show all cinemas
    if (noFilters) {
      return cinemas;
    }

    // // b) Filters active but schedules empty or not loaded => show none
    // if (
    //   !schedules ||
    //   Object.keys(schedules).length === 0
    // ) {
    //   return [];
    // }

    // c) Otherwise, only show cinemas that have at least one matching session
    return cinemas.filter((cinema) => {
      return schedules[cinema.id] 
    });
  }, [cinemas, schedules, selectedMovies, selectedDimensions]);

  // Get geolocation data with more options for mobile
  useEffect(() => {
    console.log("Requesting geolocation...");
    if (navigator.geolocation) {
      const geoOptions = {
        enableHighAccuracy: true,
        timeout: 15000,        // Longer timeout for mobile
        maximumAge: 0          // Don't use cached position
      };

      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const location = { lat: coords.latitude, lng: coords.longitude };
          console.log("Got user location:", location);
          setInitialCenter(location);
          setUserLocation(location);
        },
        (err) => {
          console.error('Failed to get location', err.code, err.message);
          // Handle specific geolocation errors
          switch (err.code) {
            case 1: // PERMISSION_DENIED
              console.log("User denied the request for geolocation");
              break;
            case 2: // POSITION_UNAVAILABLE
              console.log("Location information is unavailable");
              break;
            case 3: // TIMEOUT
              console.log("The request to get user location timed out");
              break;
            default:
              console.log("An unknown error occurred");
          }
        },
        geoOptions
      );
    } else {
      console.log("Geolocation is not supported by this browser/device");
    }
  }, []);

  const mapOptions = {
    // one-finger pan on mobile; two finger zoom
    gestureHandling: 'greedy',
    // show/hide controls
    disableDefaultUI: true,
    fullscreenControl: false,
    clickableIcons: false,
  }

  // filter cinemas based on the schedules
  useEffect(() => {
    console.log("Cinemas:", cinemas);
    console.log("Schedules:", schedules);

  }, [cinemas, schedules])


  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}>
      <div className="Container">
        <div className="MapContainer">
          <Map
            mapId={"3a1928a2bcf36055"}
            colorScheme={ColorScheme.DARK}
            className="Map"
            options={mapOptions}
            defaultZoom={12}
            defaultCenter={initialCenter}
          >
            <MapController userLocation={initialCenter} />
            {filteredCinemas.map(cinema =>
              <CinemaMarker key={cinema.id} cinema={cinema} />
            )}
            {/* Add a marker for user's location if we have it */}
            {userLocation && (
              <AdvancedMarker position={userLocation}>
                <Pin background={"red"} borderColor={"#FFFFFF"} glyphColor={"#FFFFFF"} />
              </AdvancedMarker>
            )}
          </Map>
        </div>
      </div>
    </APIProvider>
  );
}

export default CinemaMap;
